import { render } from "./ClinicIntroduction.vue?vue&type=template&id=1a0b7338&scoped=true"
import script from "./ClinicIntroduction.vue?vue&type=script&lang=js"
export * from "./ClinicIntroduction.vue?vue&type=script&lang=js"

import "./ClinicIntroduction.vue?vue&type=style&index=0&id=1a0b7338&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a0b7338"]])

export default __exports__